export default [
  {
    // 消息
    path: '/user-center/news',
    component: resolve => require(['./Index'], resolve),
    redirect: '/user-center/news/station',
    children: [
      {
        // 消息/站内消息
        path: 'station',
        component: resolve => require(['./view/station/Index'], resolve),
      },
      {
        // 消息/接收人管理
        path: 'receiver',
        component: resolve => require(['./view/receiver/Index'], resolve),
      },
      {
        // 新建用户
        path: 'addReceiver',
        component: resolve => require(['./view/receiver/AddReceiver.vue'], resolve),
        meta: {
          parent: "'/user-center/news/receiver"
        }
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/modules/user-center/news/router.js